export const dateRanges = [
  {
    id: 'last-24-hours',
    labelKey: 'search/advanced-search/message-actions/action-date/last-24-hours',
  },
  {
    id: 'last-week',
    labelKey: 'search/advanced-search/message-actions/action-date/last-week',
  },
  {
    id: 'last-month',
    labelKey: 'search/advanced-search/message-actions/action-date/last-month',
  },
  {
    id: 'last-6-month',
    labelKey: 'search/advanced-search/message-actions/action-date/last-6-month',
  },
  {
    id: 'start-of-year',
    labelKey: 'search/advanced-search/message-actions/action-date/start-of-year',
  },
];
